import React from "react";
import {isFimcAdmin} from "../../../Utilities/LocalStorage/storageUtilities";
import {GridCell, gridConstants, GridContainer} from "../../../Components/Grid";
import {HtmlDisplay} from "../../../Components/Display";
import {CENSUS_STATUS, getCensusStatusList} from "../studentCensusConstants";
import {Button} from "../../../Components/Inputs";

interface StudentApprovalCensusViewProps {
    buttonSharedSettings: Record<string, unknown>;
    currentCensusStatus?: string;
    handleAdminReviewCensus: () => void;
    handleEndCensus: () => void;
    handleOpenCensus: () => void;
}

export const StudentApprovalCensusView: React.FC<StudentApprovalCensusViewProps> = ({
                                              buttonSharedSettings,
                                              currentCensusStatus,
                                              handleAdminReviewCensus,
                                              handleEndCensus,
                                              handleOpenCensus
                                          }) => {


    const handleEndCensusClick = () => {
        if (confirm(`Are you sure you wanted to end the Census, this will allow the users to add and update students?`))
            handleEndCensus();
    };

    const handleAdminReviewCensusClick = () => {
        if (confirm(`Are you sure you wanted to begin "Admin Review Census". \n\n This action will restrict the patron from add/edit of students. \n\nAre you sure you want to continue?`))
            handleAdminReviewCensus();
    };

    const handleOpenCensusClick = () => {
        if (confirm(`Are you sure you wanted to begin the Census. 
                    \n\n This action will update all students with "Student Status: Active" and "Student Approval Status: Approved" to "Student Approval Status: NEED INFO".
                    \n\n Also this will MASS UNCHECK the patron certification of students with statuses "Approved", "Need Info" and "Pending".
                    \n\nAre you sure you want to CONTINUE?`))
            handleOpenCensus();
    };

    return <>
        <GridContainer className={`margin--top`} hasPaddingX isFlush>
            <GridCell {...buttonSharedSettings} medium_offset={gridConstants.column.SIX}>
                <HtmlDisplay
                    html={`<b>Current census status: ${getCensusStatusList().find(f => f.id === currentCensusStatus)?.text.toUpperCase() || ``}</b>`}
                    name={`census-status`}
                />
            </GridCell>
            {
                isFimcAdmin() &&
                <GridCell {...buttonSharedSettings} className={`text-center`}>
                    <>
                        {
                            currentCensusStatus === CENSUS_STATUS.CensusEnd.id &&
                            <Button
                                isCollapsed
                                label={`Open Census`}
                                name="btnOpenCensus"
                                onClick={handleOpenCensusClick}
                            />
                        }
                        {
                            currentCensusStatus === CENSUS_STATUS.CensusOpen.id &&
                            <Button
                                isCollapsed
                                label="Admin Review Census"
                                name="btnAdminReviewCensus"
                                onClick={handleAdminReviewCensusClick}
                            />
                        }
                        {
                            currentCensusStatus === CENSUS_STATUS.CensusFimcAdminReview.id &&
                            <Button
                                isCollapsed
                                label="End Census"
                                name="btnBeginCensus"
                                onClick={handleEndCensusClick}
                            />
                        }
                    </>
                </GridCell>
            }
        </GridContainer>
    </>;
}